import { useContext } from 'react'
import { BrazeProviderContext } from '~/providers'

export const useBraze = () => {
  return useContext(BrazeProviderContext)
}
